import type { LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { AddLinkedAccountButton } from "./AddLinkedAccountButton";
import { PlatformLabel } from "./PlatformLabel";

interface PlatformSectionHeaderProps {
  platform: LinkedAccountPlatform;
}

export const PlatformSectionHeader = ({ platform }: PlatformSectionHeaderProps) => {
  return (
    <div className="flex w-full items-center justify-between">
      <PlatformLabel platform={platform} />
      <AddLinkedAccountButton platform={platform} />
    </div>
  );
};
